import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    minicart: undefined,
    hovering: false,
    justAdded: false,
    lastAdded: undefined,
};
export default createSlice({
    name: 'minicart',
    initialState: initialState,
    reducers: {
        updateMinicart: (state, action) => {
            state.minicart = action.payload;
        },
        setHoveringMinicart: (state) => {
            state.hovering = true;
        },
        setNotHoveringMinicart: (state) => {
            state.hovering = false;
        },
        setJustAddedMinicart: (state, action) => {
            state.justAdded = true;
            state.lastAdded = action.payload;
        },
        setNotJustAddedMinicart: (state) => {
            state.justAdded = false;
        },
    },
});
